module.exports = __webpack_public_path__ + "static/media/Portrait-10063.76869d9a.jpg";